import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePopUp from "./date_popup.js";
import TaskPopUp from "./task_popup.js";
import "../styles/history_popup.css";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const ClientSygnPopUp = (props) => {
  const [loading, setLoading] = useState(true);
  const [lawsuitsDetails, setLawsuitsDetails] = useState([]);

  const fetchLawsuitData1 = async () => {
    var body = {
      id: +props.clientId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsData1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var dat = JSON.parse(
            el.value
              .replaceAll(/\\n/g, "\\n")
              .replaceAll(/\\'/g, "\\'")
              .replaceAll(/\\"/g, '\\"')
              .replaceAll(/\\&/g, "\\&")
              .replaceAll(/\\r/g, "\\r")
              .replaceAll(/\\t/g, "\\t")
              .replaceAll(/\\b/g, "\\b")
              .replaceAll(/\\f/g, "\\f")
              .replaceAll(/\n/g, "\\\\n")
              .replaceAll(/\r/g, "\\\\r")
              .replaceAll(/\t/g, "\\\\t")
          );
          arr.push({ data: dat, link: el.link });
        });
        setLawsuitsDetails(arr);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const deleteSygn = async (e) => {
    setLoading(true);

    var lawsuitId = 0;

    var sygn = props.clientsSygnData.filter(
      (el) => +el.id === +e.target.value
    )[0].sygn;

    lawsuitsDetails.map((el) => {
      if (el.data.signature === sygn) {
        lawsuitId = el.id;
      }
    });

    var body = {
      id: e.target.value,
      clientId: props.clientId,
      lawsuitId: lawsuitId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSygnClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    props.logClientAction("Usunięto sygnaturę sprawy", props.clientId);
    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "sygnaturę",
    }).then((result) => {
      props.close();
    });
  };

  useEffect(() => {
    props.logClientAction("Otwarto tabelę sygnatur", props.clientId);
    fetchLawsuitData1();
  }, []);

  return (
    <>
      <div className="mainContainerDatePopUp">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div className="hearingTitle">
              Sygnatury klienta{" "}
              <span className="highlight">{props.clientName}</span>
            </div>
            <div className="hearings_history_box">
              <div className="hearings_data_box">
                <div
                  id="hearings_data_header"
                  className="hearings_data_box_row"
                >
                  <div className="hearings_data_box_col">Sygnatura</div>
                  <div className="hearings_data_box_col">Sąd</div>
                  <div className="hearings_data_box_col">Data od</div>
                  <div className="hearings_data_box_col">Kto dodał</div>
                  <div className="hearings_data_box_col">
                    Sygnatura poboczna?
                  </div>
                  <div className="hearings_data_box_col"></div>
                </div>
                {props.clientsSygnData
                  .sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                  })
                  .filter((el) => +el.clientId === +props.clientId)
                  .map((el) => (
                    <>
                      <div className="hearings_data_box_row">
                        <div className="hearings_data_box_col">{el.sygn}</div>
                        <div className="hearings_data_box_col">
                          {el.court ? el.court : "brak danych"}
                        </div>
                        <div className="hearings_data_box_col">
                          {new Date(el.date).getFullYear() +
                            "-" +
                            (new Date(el.date).getMonth() + 1 < 10
                              ? "0" + (new Date(el.date).getMonth() + 1)
                              : new Date(el.date).getMonth() + 1) +
                            "-" +
                            (new Date(el.date).getDate() < 10
                              ? "0" + new Date(el.date).getDate()
                              : new Date(el.date).getDate())}
                        </div>
                        <div className="hearings_data_box_col">{el.who}</div>
                        <div
                          className="hearings_data_box_col"
                          style={{ textAlign: "center" }}
                        >
                          {el.addF === "true" ? "TAK" : "NIE"}
                        </div>
                        <div className="hearings_data_box_col">
                          <button
                            className="viewButton"
                            value={el.id}
                            onClick={deleteSygn}
                          >
                            USUŃ
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ClientSygnPopUp;
